/**
 * Generated file, do not edit directly!
 */

/** Timings define the duration of an animation. */

const Instant = {
  /** Css custom property: --dt-timings-instant-default. Default value: 0ms. */
  Default: 'var(--dt-timings-instant-default, 0ms)',
};
const Offset = {
  /** Css custom property: --dt-timings-offset-short. Default value: 20ms. */
  Short: 'var(--dt-timings-offset-short, 20ms)',
  /** Css custom property: --dt-timings-offset-medium. Default value: 30ms. */
  Medium: 'var(--dt-timings-offset-medium, 30ms)',
  /** Css custom property: --dt-timings-offset-long. Default value: 100ms. */
  Long: 'var(--dt-timings-offset-long, 100ms)',
  /** Css custom property: --dt-timings-offset-default. Default value: 50ms. */
  Default: 'var(--dt-timings-offset-default, 50ms)',
};
const Fast = {
  /** Css custom property: --dt-timings-fast-quick. Default value: 150ms. */
  Quick: 'var(--dt-timings-fast-quick, 150ms)',
  /** Css custom property: --dt-timings-fast-default. Default value: 170ms. */
  Default: 'var(--dt-timings-fast-default, 170ms)',
  /** Css custom property: --dt-timings-fast-moderate. Default value: 200ms. */
  Moderate: 'var(--dt-timings-fast-moderate, 200ms)',
};
const Base = {
  /** Css custom property: --dt-timings-base-quick. Default value: 250ms. */
  Quick: 'var(--dt-timings-base-quick, 250ms)',
  /** Css custom property: --dt-timings-base-default. Default value: 300ms. */
  Default: 'var(--dt-timings-base-default, 300ms)',
  /** Css custom property: --dt-timings-base-moderate. Default value: 350ms. */
  Moderate: 'var(--dt-timings-base-moderate, 350ms)',
};
const Slow = {
  /** Css custom property: --dt-timings-slow-default. Default value: 400ms. */
  Default: 'var(--dt-timings-slow-default, 400ms)',
  /** Css custom property: --dt-timings-slow-moderate. Default value: 600ms. */
  Moderate: 'var(--dt-timings-slow-moderate, 600ms)',
  /** Css custom property: --dt-timings-slow-gentle. Default value: 800ms. */
  Gentle: 'var(--dt-timings-slow-gentle, 800ms)',
};
const Slowest = {
  /** Css custom property: --dt-timings-slowest-default. Default value: 1000ms. */
  Default: 'var(--dt-timings-slowest-default, 1000ms)',
  /** Css custom property: --dt-timings-slowest-moderate. Default value: 1200ms. */
  Moderate: 'var(--dt-timings-slowest-moderate, 1200ms)',
  /** Css custom property: --dt-timings-slowest-gentle. Default value: 1500ms. */
  Gentle: 'var(--dt-timings-slowest-gentle, 1500ms)',
};
export default {
  Instant,
  Offset,
  Fast,
  Base,
  Slow,
  Slowest,
};
